import { ISSUEINVOICE } from "../constants/ActionTypes";

const initialState = {
  DEFAULTTITLEDATA:{},
  INVOICEDATA:{},
  INVOICEMSG: ''
};

export default function ( state = initialState, action = {} ){
  switch( action.type ){
    case ISSUEINVOICE.DEFAULTTITLEDATA:
      return Object.assign({},state,{
        DEFAULTTITLEDATA:action.DEFAULTTITLEDATA
      })
    case ISSUEINVOICE.INVOICEDATA:
      return Object.assign({},state,{
        INVOICEDATA:action.INVOICEDATA
      })
    case ISSUEINVOICE.INVOICEMSG:
      return Object.assign({},state,{
        INVOICEMSG:action.INVOICEMSG
      })
    default:
      return state;
  }
}




// WEBPACK FOOTER //
// ./common/reducers/issueInvoice.js